import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import SubscriberPayerForm from './subscriber-payer-form';
import { ClaimEditorStore } from '../../../../stores/claim-editor';
import * as CS from '../section.styles';
import { BaseButton } from '../../../base/button';

interface ISubscriberPayerListProps {
    initialItems?: any[];
    claimEditorStore: ClaimEditorStore;
}

export const SubscriberPayerList: React.FunctionComponent<ISubscriberPayerListProps> = observer(
    ({ initialItems, claimEditorStore }) => {
        const [isInitialized, setIsInitialized] = useState(false);

        useEffect(() => {
            if (isInitialized) {
                return;
            }
            const fromStore = claimEditorStore.subscribers;
            const hasStoreItems = Array.isArray(fromStore) && fromStore.length > 0;
            const hasInitialItems = Array.isArray(initialItems) && initialItems.length > 0;
            if (!hasStoreItems && hasInitialItems) {
                claimEditorStore.updateSubscribers(initialItems as any);
            }
            setIsInitialized(true);
        }, [claimEditorStore, initialItems, isInitialized]);

        const items = isInitialized
            ? Array.isArray(claimEditorStore.subscribers)
                ? claimEditorStore.subscribers
                : []
            : Array.isArray(claimEditorStore.subscribers) && claimEditorStore.subscribers.length > 0
              ? claimEditorStore.subscribers
              : (initialItems ?? []);

        const handleAdd = (): void => {
            const current = Array.isArray(claimEditorStore.subscribers) ? claimEditorStore.subscribers : [];
            const next = current.length >= 3 ? current : [...current, {}];
            claimEditorStore.updateSubscribers(next as any);
        };

        const handleRemove = (index: number): void => {
            const current = Array.isArray(claimEditorStore.subscribers) ? claimEditorStore.subscribers : [];
            const next = current.filter((_, i) => i !== index);
            claimEditorStore.updateSubscribers(next as any);
        };

        return (
            <div>
                {items.map((item, idx) => (
                    <CS.SectionContainer key={idx}>
                        <CS.SectionHeader>
                            <CS.SectionTitle>
                                {idx === 0 ? 'Primary' : idx === 1 ? 'Secondary' : 'Tertiary'}
                            </CS.SectionTitle>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <BaseButton
                                    variant="outlined"
                                    onClick={(): void => {
                                        claimEditorStore.copySubscriberFromPatient(idx);
                                    }}>
                                    Copy From Patient
                                </BaseButton>
                                <BaseButton variant="warning" onClick={(): void => handleRemove(idx)}>
                                    ✕ Remove Subscriber
                                </BaseButton>
                            </div>
                        </CS.SectionHeader>
                        <SubscriberPayerForm claimEditorStore={claimEditorStore} data={item} subscriberIndex={idx} />
                    </CS.SectionContainer>
                ))}

                <CS.ButtonContainer>
                    <BaseButton variant="primary" onClick={handleAdd} disabled={items.length >= 3}>
                        + Add Subscriber
                    </BaseButton>
                </CS.ButtonContainer>
            </div>
        );
    },
);

export default SubscriberPayerList;
